import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(30, 41, 59, 0.95) 0%, rgba(30, 41, 59, 0.85) 50%, rgba(30, 41, 59, 0.75) 100%), url('https://public.readdy.ai/ai/img_res/8cc6b6ea423470d8447d0ed72df026fb.jpg')`
      }}
    >
      <div className="container mx-auto px-6 lg:px-12 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="font-serif text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              The Mirror Effect: Why AI mimics our worst habits.
            </h1>
            <p className="text-xl lg:text-2xl text-slate-200 leading-relaxed">
              We bridge the gap between Technical AI Alignment and Risk Engineering.
            </p>
            <div className="flex flex-wrap gap-4">
              <button 
                className="bg-red-800 hover:bg-red-900 text-white px-8 py-4 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer rounded-lg"
                onClick={() => navigate('/open-letter-governor-newsom')}
              >
                Read Press Release
              </button>
              <button 
                className="bg-white hover:bg-slate-100 text-red-800 px-8 py-4 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer rounded-lg border-2 border-white"
                onClick={() => navigate('/get-book')}
              >
                📚 Get the Book
              </button>
            </div>
          </div>
          <div className="hidden lg:block">
            {/* Right side reserved for background image visibility */}
          </div>
        </div>
      </div>
    </section>
  );
}
